import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WeeeFeedbackComponent } from '~shared/modules/weee-landing-page/components/weee-feedback/weee-feedback.component';

const routes: Routes = [
  {
    /*
     * This component is being shown only from emails that is sent
     * to the customers when they make a purchase a product that is
     * Available for Take Back Service and they either click Accept
     * Or Reject Links.
     * */
    path: '',
    component: WeeeFeedbackComponent,
    data: {
      title: 'TITLE.PAGE.WEEE',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WeeeLandingPageRoutingModule {}
